export default __webpack_public_path__ + "static/media/Power of the Past.f356cc95.png";